<template>
  <div class="notices-container">
    <div class="common-title">
      <span>通知</span>
      <span @click="handle2NewList('notices')">更多<van-icon name="arrow"/></span>
    </div>
    <div v-if="notes.length" class="notices-item-container">
      <div @click="handle2NewDetailById(item)" class="notices-item" v-for="item in notes" :key="item.id">
        <div class="title van-ellipsis">{{ item.title }}</div>
        <div class="time">{{ item.time | formatDate('MM-dd') }}</div>
      </div>
    </div>
    <van-empty v-else description="暂无通知"></van-empty>
  </div>
</template>

<script>
export default {
  props: ['notes'],
  methods: {
    handle2NewDetailById(item) {
      this.$router.push(`/new/${item.id}`)
    },
    handle2NewList(type) {
      this.$router.push(`/${type}More`)
    }
  }
}
</script>

<style lang="scss" scoped>
/* 通知 */
.notices-container {
  margin-bottom: 20px;
  .notices-item-container {
    background: #fff;
    border-radius: 6px;
    padding: 14px;
  }
  .notices-item-container .notices-item {
    display: flex;
    padding: 16px 0;
    align-items: center;
    .title {
      flex: 1;
      padding-right: 10px;
      font-size: 14px;
      color: #303133;
    }
    .time {
      font-size: 12px;
      color: #909399;
    }
  }
}
// common
.common-title {
  padding: 16px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  span {
    &:nth-child(1) {
      font-size: 16px;
      color: rgba(48, 49, 51, 1);
      font-weight: 700;
    }
    &:nth-child(2) {
      color: #909399;
      font-size: 13px;
    }
  }
}
</style>
